export * from './idea.service';



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/services/index.ts